import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommPersonIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.0387 16.126C13.9575 14.2913 10.0425 14.2913 6.96128 16.126 6.79338 16.226 6.60939 16.3303 6.41668 16.4397 5.70407 16.844 4.87205 17.316 4.29196 17.8838 3.93183 18.2363 3.77832 18.5271 3.75376 18.7517 3.73427 18.9301 3.77936 19.2242 4.22999 19.6535 5.26584 20.6404 6.31841 21.25 7.59086 21.25H16.4091C17.6816 21.25 18.7341 20.6404 19.77 19.6535 20.2206 19.2242 20.2657 18.9301 20.2462 18.7517 20.2217 18.5271 20.0682 18.2363 19.708 17.8838 19.1279 17.316 18.2959 16.844 17.5833 16.4397 17.3906 16.3303 17.2066 16.226 17.0387 16.126zM17.8061 14.8372C17.9224 14.9064 18.0661 14.9875 18.2288 15.0793 18.9416 15.4814 20.0191 16.0893 20.7573 16.8118 21.2189 17.2637 21.6576 17.8592 21.7373 18.5888 21.8221 19.3646 21.4837 20.0927 20.8047 20.7396 19.6332 21.8556 18.2274 22.75 16.4091 22.75H7.59086C5.77255 22.75 4.36677 21.8556 3.19532 20.7396 2.5163 20.0927 2.17784 19.3646 2.26265 18.5888 2.34239 17.8592 2.78104 17.2637 3.24271 16.8118 3.98088 16.0893 5.05839 15.4814 5.7712 15.0793 5.93387 14.9875 6.07754 14.9064 6.19386 14.8372 9.74791 12.7209 14.2521 12.7209 17.8061 14.8372zM12 2.75C9.92893 2.75 8.24999 4.42893 8.24999 6.5 8.24999 8.57107 9.92893 10.25 12 10.25 14.0711 10.25 15.75 8.57107 15.75 6.5 15.75 4.42893 14.0711 2.75 12 2.75zM6.74999 6.5C6.74999 3.6005 9.1005 1.25 12 1.25 14.8995 1.25 17.25 3.6005 17.25 6.5 17.25 9.39949 14.8995 11.75 12 11.75 9.1005 11.75 6.74999 9.39949 6.74999 6.5z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
